<template>

    <div class="littleArticleCarrousel">

        <h1 v-if="title" class="appearEffect">{{ title }}</h1>
        <h2 v-if="subTitle" class="appearEffect" v-html="subTitle"></h2>

        <carousel class="carrousel appearEffect"
                  :class="className"
                  :nav="false"
                  :dots="false"
                  :slideBy="slideBy"
                  :responsive="{0:{items:1},768:{items:2},1024:{items:3}}"
                  @translated="translatedCarrousel"
                  @initialize="initializeCarrousel" >

            <template v-if="!noNav" slot="prev" class="carrousel_prev">
                <FaIcon name="chevron-left" />
            </template>

            <template v-if="!noNav" slot="next" class="carrousel_next">
                <FaIcon name="chevron-right" />
            </template>

            <LittleArticle v-for="(article, index) in articles"
                           :title="article.title"
                           :subtitle="article.subtitle"
                           :keyfigure="article.keyfigure"
                           :content="article.content"
                           :caption="article.caption"
                           :image="article.image"
                           :imageBottom="article.imageBottom"
                           :link="article.link"
                           :events="article.events"
                           :noCollapse="article.noCollapse"
                           :middleCollapse="article.middleCollapse"
                           :key="index"
                           :class="{'reduce_title': isReduceTitle}"
                           :isWhite=isWhite
            ></LittleArticle>

        </carousel>

    </div>

</template>



<script>

    import carousel from 'vue-owl-carousel';
    import LittleArticle from '../components/LittleArticle.vue';
    import Arrow from '../components/Arrow.vue';
    import FaIcon from "./FaIcon";

    export default {
        name: 'LittleArticleCarrousel',
        components: {FaIcon, LittleArticle, carousel, Arrow},
        props: {
            articles: {
                type: Array,
                default: [],
            },
            title: {
                type: String,
                default: '',
            },
            subTitle: {
                type: String,
                default: '',
            },
            noCollapse: {
                Boolean,
                default: false,
            },
            middleCollapse: {
                Boolean,
                default: false,
            },
            className: {
                type: String,
                default: '',
            },
            slideBy: {
                type: String,
                default: 'page',
            },
            noNav: {
                Boolean,
                default: false,
            },
            isReduceTitle: {
                type: Boolean,
                default: false,
            },
            isWhite: {
                type: Boolean,
                default: false,
            },
        },
        mounted: function(){
            //console.debug('mounted');
            this.$events.fire('ButtonMagneticUpdate');
        },
        methods: {
            translatedCarrousel: function() {
                //console.debug('translatedCarrousel');
                this.$events.fire('ButtonMagneticUpdate');
                this.$events.fire('LittleArticleCarrousel-translated');
            },
            initializeCarrousel: function() {
                //console.debug('initializeCarrousel');
                this.$events.fire('ButtonMagneticUpdate');
            },
        },
    };
</script>

<style scoped lang="scss">

    h1{
        font-size: 5.5rem;
        line-height: 1em;
        font-weight: $FW-bold;
        text-transform: initial;
        margin-top: $G-default * 3;
        margin-bottom: 0;
        letter-spacing: 0.05em;
        text-align: center;
    }
    h2{
        font-size: 3.2rem;
        font-weight: $FW-bold;
        text-transform: initial;
        margin-top: $G-default / 3;
        letter-spacing: 0.05em;
        text-align: center;
        max-width: 60%;
        margin-left: auto;
        margin-right: auto;
    }



    .littleArticleCarrousel{

        .carrousel{
            padding: 0 10vw;
            position: relative;
            margin-top: $G-default*1.5;

            span{
                svg {
                    cursor: pointer;
                }
            }

            .chevron-left{
                position: absolute;
                left: $G-default;
                top: 50%;
                width: 2rem;
                height: auto;

            }
            .chevron-right{
                position: absolute;
                right: $G-default;
                top: 50%;
                width: 2rem;
                height: auto;
             }
        }

    }

    // bidouille pour corrigé le bug de la fleche de droite qui s'affiche meme si nous n'avons que 3 item
    @include breakpoint(md){
        .artyMirrorCarrousel .chevron-right{
            opacity: 0;
        }
    }


</style>